import React from 'react';
import { Helmet } from 'react-helmet';
import partners from '../data/partners.json';
import { buildTitle, DEFAULT_OG_IMAGE, SITE_URL } from '../utils/seo';

export default function Partners() {
  return (
    <>
      <Helmet>
        <title>{buildTitle('Partners & Collaborations')}</title>
        <meta
          name="description"
          content="Explore Sista Kyerewaa collaborations and trusted partnerships that support African families and diaspora communities in Germany."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={`${SITE_URL}/partners`} />
        <meta property="og:title" content={buildTitle('Partners & Collaborations')} />
        <meta property="og:description" content="Trusted community and brand partnerships that align with integration, culture, and life-in-Germany support." />
        <meta property="og:image" content={DEFAULT_OG_IMAGE} />
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:title" content={buildTitle('Partners & Collaborations')} />
        <meta property="twitter:description" content="Trusted community and brand partnerships that align with integration, culture, and life-in-Germany support." />
        <meta property="twitter:image" content={DEFAULT_OG_IMAGE} />
        <link rel="canonical" href={`${SITE_URL}/partners`} />
      </Helmet>
      <main className="max-w-5xl mx-auto px-6 py-16">
        <div className="text-center mb-10">
          <p className="text-xs uppercase tracking-[0.35em] text-[#7b7671]">Partners</p>
          <h1 className="font-display text-4xl md:text-5xl mt-4 text-[#1c1b1a]">Collaborations</h1>
          <p className="text-[#6a6661] mt-4">
            A growing list of brand collaborations and community partnerships.
          </p>
        </div>

        <div className="grid gap-6 md:grid-cols-2">
          {partners.map((partner) => (
            <a
              key={partner.name}
              href={partner.link}
              target="_blank"
              rel="noopener noreferrer"
              className="border border-stone-200 bg-white/70 p-6 hover:border-[#bdb7b0] transition-colors"
            >
              <img src={partner.logo} alt={`${partner.name} logo`} className="w-full h-28 object-contain" />
              <p className="text-xs uppercase tracking-[0.25em] text-[#7b7671] mt-4">{partner.role}</p>
              <h2 className="font-display text-2xl text-[#2d2b29] mt-2">{partner.name}</h2>
              <p className="text-[#6a6661] mt-3">{partner.summary}</p>
            </a>
          ))}
        </div>

        <div className="grid gap-6 md:grid-cols-2 mt-10">
          <div className="border border-stone-200 bg-[#f5f4f2] p-8">
            <p className="text-xs uppercase tracking-[0.25em] text-[#7b7671]">Lemfi offer</p>
            <h2 className="font-display text-3xl text-[#2d2b29] mt-3">Get €15 free with Lemfi</h2>
            <p className="text-[#6a6661] mt-3">
              I’m proud to partner with Lemfi. Download the Lemfi app and sign up with my referral code
              <strong className="text-[#2d2b29]"> sistakyerewaa </strong>
              to get €15 free. Fast, reliable transfers made easy for our community.
            </p>
            <a
              href="https://referral.lemfi.com/WCZBWMjlQ1b"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center mt-5 px-6 py-3 border border-[#c9c5bf] text-xs uppercase tracking-[0.25em] text-[#2d2b29] hover:bg-[#e7e4df] transition-colors"
            >
              Learn more
            </a>
          </div>
          <div className="border border-stone-200 bg-[#f5f4f2] p-8">
            <p className="text-xs uppercase tracking-[0.25em] text-[#7b7671]">Learn Deutsch GH offer</p>
            <h2 className="font-display text-3xl text-[#2d2b29] mt-3">Get 300 cedis free in Ghana</h2>
            <p className="text-[#6a6661] mt-3">
              Register with Learn Deutsch GH using my referral code
              <strong className="text-[#2d2b29]"> sistakyerewaa </strong>
              and receive 300 cedis free. Locations: Accra and Kumasi.
            </p>
            <a
              href="https://learndeutsch24.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center mt-5 px-6 py-3 border border-[#c9c5bf] text-xs uppercase tracking-[0.25em] text-[#2d2b29] hover:bg-[#e7e4df] transition-colors"
            >
              Learn more
            </a>
          </div>
        </div>
      </main>
    </>
  );
}
